import { IEnv } from "../../../shared/interfaces/IEnv";

export default {
    client: {
        name: "araucaria",
        nomePrefeitura: "Prefeitura Municipal de Araucária",
        logo: "https://d1cge5fflrvk0g.cloudfront.net/araucaria/logos/logos.png",
        brasao: "https://d1cge5fflrvk0g.cloudfront.net/araucaria/logos/brasao.png",
        municipio: "| ARAUCÁRIA - PR",
    },
    webgeo: {
        coordinatesPattern: "EPSG:32722",
        bci: {
            nomeSecretaria: "Secretaria Municipal de Finanças",
        },
        confrontante: {
            informacoesRodape:
                "Praça Edmundo Mercer, nº 34, Centro - CEP 84.300.000 - Tibagi-PR  Telefone: (42) 3916-2200 Email: comunicacao@tibagi.pr.gov.br",
            nomeSecretaria:
                "Secretaria Municipal de Desenvolvimento Urbano e Logística",
        },
        consultaPrevia: {
            nomeSecretaria: "Secretaria Municipal de Urbanismo",
            contact: {
                email: "xxx",
                endereco: "xxx",
                horarioAtendimento: "xxx",
                telefone: "xxx",
            },
            leiUsoDeSolo:
                "PARÂMETROS DE USO DO SOLO - Anexo (X) - Lei no XXXX/XXXX",
            leiVagasDeEstacionamento:
                "VAGAS PARA ESTACIONAMENTO anexo à lei XXXX/XXXXX",
        },
        config: {
            bci: true,
            confrontante: false,
            consultaPrevia: true,
            iptu: false,
            laws: false,
        },
        map: {
            center: [-49.4007499, 25.5905259],
            zoom: 19,
        },
    },
    api: {
        url: "http://localhost:3330",
    },
    geoserver: {
        url: "https://geoserver.araucaria.pr.gov.br:8080/",
    },
} as IEnv;
